import { FormFieldTypes } from "../../../../../data/formFieldType";

export const ApproveRequirementData = {
  name: "AdditionalInfo",
  initialState: {
    channel: null,
    requirementSection: null,
    requirementName: null,
    requirementDescription: "",
    documentToBeSubmitted: null,
  },
  formFields: [
    {
      id: "channel",
      lable: "Channel",
      Field_Name: "Channel",
      fieldType: FormFieldTypes.SELECT,
      dataField: "channel",
      fieldSetting: {
        placeholder: "",
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-11 mb-3",
      },
    },
    {
      id: "requirementSection",
      lable: "Requirement Section",
      Field_Name: "Requirement Section",
      fieldType: FormFieldTypes.SELECT,
      dataField: "requirementSection",
      fieldSetting: {
        placeholder: "",
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-11 mb-3",
      },
    },
    {
      id: "requirementName",
      lable: "Requirement Name",
      Field_Name: "Requirement Name",
      fieldType: FormFieldTypes.INPUT,
      dataField: "requirementName",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-11 mb-3",
      },
    },

    {
      id: "requirementDescription",
      lable: "Requirement Description",
      Field_Name: "Requirement Description",
      fieldType: FormFieldTypes.CONFIGURABLE_CKEDITOR,
      dataField: "requirementDescription",
      fieldSetting: {
        placeholder: "",
        allowSpace: false,
        toolbar: [
          'undo',
          'redo',
          '|',
          'heading',
          '|',
          'bold',
          'italic',
          'underline',
          'bulletedList',
          'numberedList',
          'fontFamily',
          'fontColor',
          'fontBackgroundColor',
          'strikethrough',
          'alignment'
        ]
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-11 mb-3 h-40",
      },
    },
    {
      id: "documentToBeSubmitted",
      lable: "Document to be Submitted",
      Field_Name: "Document to be Submitted",
      fieldType: FormFieldTypes.CONFIGURABLE_CKEDITOR,
      dataField: "documentToBeSubmitted",
      fieldSetting: {
        placeholder: "",
        allowSpace: false,
        toolbar: [
          'undo',
          'redo',
          '|',
          'heading',
          '|',
          'bold',
          'italic',
          'underline',
          'bulletedList',
          'numberedList',
          'fontFamily',
          'fontColor',
          'fontBackgroundColor',
          'strikethrough',
          'alignment'
        ]
      },
      validation: [],
      style: {
        containerCss: "col-md-11 mb-3 h-40",
      },
    },

  ],
  formSetting: {
    isViewOnly: false,
  },
};
